export default __webpack_public_path__ + "static/media/Headdress of the Sanguine Disciple (nm).0812b080.jpg";